import { EvaChart } from "constants/charts.enums";
import { ChartTypeParamFeature } from "types/charts";

import { ChartAxisType } from "models/chart";

import { getAxisFieldSelection } from "components/charts/hooks/useAxisFieldSelection";

import { BoxPlotDisplayMode, resolveBoxPlotDisplayMode } from "./boxPlotDisplayMode";

/**
 * The chartTypeParam field each axis plots, or undefined when the axis plots something else.
 * chartTypeParam carries over on a chart type switch, so a field left behind by the previous
 * chart must not label an axis that has no field picker (EVA-504).
 */
export function getAxisFieldProperties(
  chartType: EvaChart,
  chartTypeParam: Maybe<Partial<ChartTypeParamFeature>>,
  boxPlotModes: { jitterActive?: boolean; violinActive?: boolean } = {}
): Record<ChartAxisType, Maybe<string>> {
  const isJitter = resolveBoxPlotDisplayMode(boxPlotModes) === BoxPlotDisplayMode.Jitter;
  const hasPicker = getAxisFieldSelection(chartType, isJitter);
  return {
    x: hasPicker.x ? chartTypeParam?.properties?.x?.property : undefined,
    y: hasPicker.y ? chartTypeParam?.properties?.y?.property : undefined
  };
}
